export default __webpack_public_path__ + "static/19-32a7a76013c0e2ae301e521b37d4a4cd.webp";